import Home from './components/Home'
import Pro from './components/Pro'
import Info from './components/Info'

export default [
  {
    name: 'home',
    path: '/',
    component: Home
  },
  {
    name: 'pro',
    path: '/pro/:id/',
    component: Pro
  },
  {
    name: 'info',
    path: '/info/:id/',
    component: Info
  }
]



// WEBPACK FOOTER //
// ./src/routes.js